import classNames from "classnames";
import { Flex, Space } from "antd";
import { mailSupport, telegramSupport } from "@/shared/constants/umarta-links";
import { MailIcon, TelegramIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  gap?: number;
  className?: string;
  hideIcons?: boolean;
  iconStroke?: string;
};

export const SupportLinks: FC<Props> = ({ gap = 10, className, iconStroke, hideIcons }) => {
  return (
    <Flex vertical gap={gap} className={classNames(styles.root, className)}>
      <Space>
        {!hideIcons && <TelegramIcon stroke={iconStroke} />}
        <a
          target="_blank"
          className={styles.row}
          rel="noopener noreferrer"
          href={`https://t.me/${telegramSupport}`}
        >
          {" "}
          @{telegramSupport}
        </a>
      </Space>
      <Space>
        {!hideIcons && <MailIcon stroke={iconStroke} />}
        <a
          target="_blank"
          className={styles.row}
          rel="noopener noreferrer"
          href={`mailto:${mailSupport}`}
        >
          {" "}
          {mailSupport}
        </a>
      </Space>
    </Flex>
  );
};
